import { CameraIcon } from "~/common/components";

export const CameraCircle = () => (
  <div className="absolute bottom-0 right-0 flex size-6 transform items-center justify-center rounded-full bg-primary-500 text-white">
    <CameraIcon />
  </div>
);
